import { serverUrl } from '../config';

const wmMpOauth = async ({
  options,
  onSuccess,
  onError,
  redirectOnSuccess = true,
}) => {
  try {
    const onboardStartUrl = `${serverUrl}/onboarding/walmart/mp-api/start`;
    const redirectUri = 'https://dashboard.limitless.tech/onboarding/oauth/walmart';
    const response = await fetch(onboardStartUrl, options);
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text);
    }

    const data = await response.json();

    if (data.referenceId && data.referenceId > 0) {
      if (redirectOnSuccess) {
        const redirectLink = `https://login.account.wal-mart.com/authorize?responseType=code&clientId=${data.clientId}&redirectUri=${redirectUri}&nonce=${data.referenceId}&state=${data.referenceId}&clientType=seller`;
        window.location.href = redirectLink;
      }
    } else {
      throw new Error('We are having issues processing your request, please try again later. ERROR 00003');
    }

    onSuccess?.(data);
  } catch (error) {
    onError?.(error);
  }
};

const wmMpDisconnect = async ({
  options,
  onSuccess,
  onError,
}) => {
  try {
    const disconnectUrl = `${serverUrl}/onboarding/walmart/mp-api/disconnect`;
    const response = await fetch(disconnectUrl, options);
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text);
    }

    const data = await response.json();

    if (data && data.status === 'SUCCESS') {
      console.info('Disconect Complete');
    } else {
      throw new Error('We are having issues processing your request, please try again later. ERROR 00004');
    }

    onSuccess?.(data);
  } catch (error) {
    onError?.(error);
  }
};

const oauthService = {
  wmMpOauth,
  wmMpDisconnect,
};

export default oauthService;
